var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource"},[_c('div',[_vm._m(0),_c('p',{staticClass:"hit"},[_vm._v("资源访问出错, 正在加急修复中!")]),_c('p',[_vm._v("剩余"),_c('span',{staticClass:"hit"},[_vm._v(_vm._s(_vm.time))]),_vm._v("秒，进行重试资源")]),_c('p',{staticClass:"hit"},[_vm._v("*可能会重试几次，请耐心等待*")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('i',{staticClass:"el-icon-loading loading"})])
}]

export { render, staticRenderFns }